import {useEffect, useState} from 'react';
import {getRechargeCommissionRuleV2} from '../invitation.service';
import {
  RechargeCommissionRuleThresholds,
  RechargeCommissionRuleV2,
} from '../invitation.type';
import {normalizeRechargeCommissionRuleResponse} from './commission-rule.utils';

export const useRechargeCommissionRules = () => {
  const [rechargeRuleGroups, setRechargeRuleGroups] = useState<
    RechargeCommissionRuleV2[]
  >([]);
  const [ruleThresholds, setRuleThresholds] =
    useState<RechargeCommissionRuleThresholds>({});

  useEffect(() => {
    let active = true;

    getRechargeCommissionRuleV2()
      .then(response => {
        if (!active) {
          return;
        }
        const {rechargeRuleGroups: groups, ...thresholds} =
          normalizeRechargeCommissionRuleResponse(response);
        setRechargeRuleGroups(groups);
        setRuleThresholds(thresholds);
      })
      .catch(() => {
        if (active) {
          setRechargeRuleGroups([]);
          setRuleThresholds({});
        }
      });

    return () => {
      active = false;
    };
  }, []);

  return {rechargeRuleGroups, ruleThresholds};
};
